<template>
  <Modal v-if="show" title="Просмотр загруженного фото" @backdrop-click="close">
    <template slot="body">
      <div class="modal-body__wrapper_image vert-scroll">
        <div class="body__image">
          <img class="image" :src="imageSrc" />
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <button
          v-focus
          type="button"
          class="modal-default-button btn btn-danger"
          @click.stop="close"
        >
          Закрыть
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
export default {
  components: {
    Modal,
  },
  emits: ["close"],
  props: {
    imageSrc: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      handler(value) {
        if (value) {
          document.querySelector("body").style.overflow = "hidden";
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      document.querySelector("body").style.overflow = "auto";
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.body__image {
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
}

.image {
  object-fit: cover;
  width: inherit;
  height: inherit;
}

.modal-body__wrapper_image {
  max-height: 32em;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/FullsizeImageModal.vue